import React from "react";

const BadgeGradientSvg = ({ width = '10.541', height = '66' }) => {
    return (
        <svg width="50" height="50" viewBox="0 0 69 98" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="1" filter="url(#filter0_f_13505_53133)">
            <rect x="43" y="16.6328" width={width} height={height} transform="rotate(24 43 16.6328)" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_f_13505_53133" x="0.15625" y="0.632812" width="68.4727" height="96.5813" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="8" result="effect1_foregroundBlur_13505_53133"/>
            </filter>
            </defs>
        </svg>
    )
}
export default BadgeGradientSvg
